// extracted by mini-css-extract-plugin
export default {"DeleteFavorModal__Body":"DeleteFavorModal-styles__DeleteFavorModal__Body__XFf8f","DeleteFavorModal__NumberedList":"DeleteFavorModal-styles__DeleteFavorModal__NumberedList__uBiMy"};